webpackJsonp([254540915493745],{

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yup = __webpack_require__(17);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _components = __webpack_require__(8);
	
	var _data = __webpack_require__(18);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Description = function Description() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'A limited liability company (LLC) is a corporate structure whereby the members of the company cannot be held personally liable for the company\'s debts or liabilities. Limited liability companies are essentially hybrid entities that combine the characteristics of a corporation and a partnership or sole proprietorship.'
	    )
	  );
	};
	
	var fieldSets = [{
	  legend: 'Company Information',
	  fields: new Map([['orgName', {
	    label: 'LLC Name',
	    title: 'Please provide a valid corporation name',
	    'data-help-title': 'Corporation Name',
	    'data-help-text': 'Please enter the name of the corporation.',
	    validation: Yup.string().required('Please provide a valid corporation name')
	  }], ['dba', {
	    'data-help-title': 'Doing Business As (Trade Name)',
	    'data-help-text': 'Please enter the trade name of the corporation.'
	  }], ['llcMembers', {
	    component: _components.TextInput,
	    initial: 1,
	    label: 'Member in LLC',
	    validation: Yup.number().integer().moreThan(0).lessThan(1000).required('Please provide the number of LLC members')
	  }]])
	}, {
	  legend: 'Taxation of the LLC',
	  fields: new Map([['taxation', {
	    component: _components.RadioInputSimple,
	    initial: 'individual',
	    options: [{ value: 'individual', label: 'Individual/Partnership: Not taxed as a separate entity from owner(s).' }, { value: 's-corporation', label: 'S-Corporation: Planning to elect an S-Corporation tax structure.' }, { value: 'corporation', label: 'Corporation: LLC is planning to elect a Corporation tax structure.' }],
	    validation: Yup.string()
	  }]])
	}, {
	  legend: 'Owner/Mananging Member Information',
	  fields: new Map([['firstName', {
	    'data-help-title': 'Managing Member/Owner',
	    'data-help-text': 'Managing Member/Owner.'
	  }], ['middleName', {
	    'data-help-title': 'Managing Member/Owner',
	    'data-help-text': 'Managing Member/Owner.'
	  }], ['lastName', {
	    'data-help-title': 'Managing Member/Owner',
	    'data-help-text': 'Managing Member/Owner.'
	  }], ['socialSecurity', {
	    'data-help-title': 'Managing Member/Owner',
	    'data-help-text': 'Managing Member/Owner.'
	  }], ['verifySocialSecurity', {
	    'data-help-title': 'Managing Member/Owner',
	    'data-help-text': 'Managing Member/Owner.'
	  }], ['title', {
	    label: 'Business Title',
	    placeholder: 'Managing Member/Owner',
	    'data-help-title': 'Managing Member/Owner',
	    'data-help-text': 'Managing Member/Owner'
	  }], ['suffix', {
	    initial: 'DDS'
	  }]])
	}, {
	  legend: 'Business Address',
	  fields: new Map([['businessAddress'], ['businessCity'], ['businessState'], ['businessZip'], ['businessCounty'], ['mailingAddressDiff']])
	}, {
	  legend: 'Business Information',
	  fields: new Map([['businessIncCountry'], ['businessApplyReason'], ['businessActivity'], ['businessServices'], ['commonQuestionOne'], ['commonQuestionTwo'], ['commonQuestionThree'], ['commonQuestionFour'], ['businessAppliedBefore'], ['businessHireEmployees']])
	}, {
	  legend: 'Business Dates',
	  fields: new Map([['businessDateStart'], ['businessClosingMonth']])
	}, {
	  legend: 'Contact Information',
	  fields: new Map([['customerContactPhone'], ['customerContactEmail'], ['customerContactEmailVerify', {
	    label: 'Verify Contact E-mail'
	  }]])
	}];
	
	var LimitedLiabilityCompanyApplicationPage = function LimitedLiabilityCompanyApplicationPage(props) {
	  return _react2.default.createElement(_components.ApplicationFlow, _extends({
	    step: 2,
	    title: 'Limited Liability Company Application',
	    documentType: _data.documentTypes.LIMITED_LIABILITY_COMPANY,
	    description: Description,
	    fieldSets: fieldSets
	  }, props));
	};
	
	exports.default = LimitedLiabilityCompanyApplicationPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-limited-liability-company-application-js-c0fe3cdbc04aa9538181.js